<style>
.v-list-item {
  padding-left: 5px;
  padding-right: 5px;
}

.arrow-icon {
}

.mapblending {
  mix-blend-mode: multiply;
}

.arrow-icon > div {
  width: 16px;
  height: 16px;
  margin: 0;
  padding: 0;
  transform-origin: center center;
}

.v-list-item__content {
  padding: 0
}

.v-list--dense .v-list-item .v-list-item__content {
  padding: 0
}

.v-list-item--dense .v-list-item__content {
  padding: 0
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 24px;
}

.leaflet-div-icon2 {
  background: white;
  border: 3px solid red;
  font-weight: bold;
  text-align: center;
  border-radius: 50%;
  line-height: 4px;
}

.leaflet-div-icon2-hi {
  background: white;
  border: 3px solid #001aff;
  font-weight: bold;
  text-align: center;
  border-radius: 50%;
  line-height: 4px;
}

.leaflet-div-icon2-sel {
  background: white;
  border: 3px solid #5bff63;
  font-weight: bold;
  text-align: center;
  border-radius: 50%;
  line-height: 4px;
}

.leaflet-div-icon2-hi-sel {
  background: white;
  border: 3px solid #00f7ff;
  font-weight: bold;
  text-align: center;
  border-radius: 50%;
  line-height: 4px;
}

.x-foot-border {
  position: relative;
  top: 0px;
  cursor: ns-resize;
  width: 100%;
  height: 6px;
  padding: 0;
  background: aquamarine;
  align-content: center;
}

.custom-popup {
  margin: 0;
  padding: 0;
}

.foot-content {
  height: 100%;
  width: 100%;
}

.dcanvas {
  width: 1000px;
  height: 400px;
}

.listtop {
  display: flex;
  margin: 0;
  width: 100%;
  height: 26px;
  line-height: 26px;
  padding: 0;
  border: 0;
  justify-content: space-between;
}

.mybuttn {
  opacity: 0.8;
  transition-duration: .28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 24px;
  width: 24px;
  background-color: #d6d7d7;
  justify-content: center;
  vertical-align: middle;
  margin-right: 1px;
  margin-top: 0px;
}

.mybuttn-selected {
  transition-duration: .28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  height: 24px;
  width: 24px;
  justify-content: center;
  vertical-align: middle;
  margin-right: 1px;
  margin-top: 0px;
  opacity: 1;
  background-color: #cd874a;
}

.mybuttn:hover {
  background-color: #cd874a;
  transition-duration: .28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.mybuttnr {
  opacity: 0.8;
  transition-duration: .28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  border-radius: 8px;
  height: 24px;
  width: 24px;
  background-color: #d6d7d7;
  line-height: 24px;
  margin-right: 1px;
  margin-top: 0px;
}

.mybuttnr-disabled {
  opacity: 0.4;
  transition-duration: .28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  border-radius: 8px;
  height: 24px;
  width: 24px;
  background-color: #d6d7d7;
  line-height: 24px;
  margin-right: 1px;
  margin-top: 0px;
}

.mybuttnr:hover {
  opacity: 1;
  background-color: #cd874a;
  transition-duration: .28s;
  transition-property: box-shadow, transform, opacity;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
}

.menuentry {
  display: flex;
  justify-content: space-between;
  align-items: center;
  pointer-events: none;
}


.kb {
  background-color: wheat;
  border: 2px #999999;
  border-radius: 30%;
  display: flex;
  justify-content: center;
  width: 28px;
  font-size: 10px;
  font-family: Consolas, monospace;
  pointer-events: none;

}

.editlen {
  border: 2px #e3a7a7;
  border-radius: 4%;
  padding: 2px 2px 2px 2px;
  justify-content: center;
  font-size: 12px;
  font-family: Consolas, monospace;
}

.col-area-inner {
  width: 12px;
  height: 12px;
  margin: 4px;
  border-radius: 5px;
  border: 2px solid #757575;
  display: inline-block;
  vertical-align: middle;
}

.col-area-outer {
  padding: 4px;
}

html {
  overflow-y: hidden !important;
}
</style>
<style lang="scss">
.foot-border {
  margin: 0;
  left: 0;
  position: relative;
  top: 0px;
  cursor: ns-resize;
  width: 100%;
  height: 6px;
  padding: 0;
  background: #eee;

  &:before {
    display: block;
    content: "";
    width: 40px;
    height: 3px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -1.5px;
    margin-left: -20px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
  }

  &:hover {
    &:before {
      border-color: #999;
    }
  }
}
</style>
<template>
  <v-app>
    <v-main>
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
          style='z-index:20001;'
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Save joined track</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      label="Track Name*"
                      required
                      v-model="saveName"
                  ></v-text-field>
                  <v-text-field
                      label="File Name*"
                      required
                      v-model="saveFileName"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                :disabled="saveName === '' || saveFileName === ''"
                @click="dialog = false;saveEdit()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="wpdialog"
          persistent
          max-width="600px"
          style='z-index:20001;'
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Waypoint</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                >
                  <v-text-field
                      label="Name"
                      required
                      v-model="curwp.name"
                  ></v-text-field>
                  <v-text-field
                      label="Description"
                      required
                      v-model="curwp.description"
                  ></v-text-field>
                  <v-select
                      :items="wptypes"
                      label="Type"
                      v-model="curwp.type"
                      dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="wpdialog = false"
            >
              Cancel
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="wpdialog = false;saveWp()"
            >
              Update
            </v-btn>
            <v-btn
            color="blue darken-1"
            text
            @click="wpdialog = false;deleteWp()"
            >
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="eleshow"
          eager
          width="1200px"
          style='z-index:20001;'
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Elevation Plot</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <canvas ref="elecv" class="dcanvas">

              </canvas>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="eleshow = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <l-map
          ref="map"
          :zoom="zoom"
          :center="center"
          :doubleClickZoom="false"
          style="height: 100%; width: 100%"
          @click="mapClick($event)"
          @contextmenu="onMapMenu"
          @boxzoomend="onMapDrag"
          :maxZoom="maxZoom"
          @zoomend="updateZoom"
          @moveend="updateZoom"
          @mousemove="onMapMouseMove($event)"
          @keypress="onMapKey($event)"
          @keyup="onMarkerKey($event)"
          :options="mapOptions">
        <v-geosearch :options="geosearchOptions"></v-geosearch>
        <l-control-layers position="topright"></l-control-layers>

        <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :options="tileProvider.tileOptions"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution"
            :opacity="tileProvider.opacity"
            :layer-type="tileProvider.layerType"
            :tile-layer-class="tileProvider.layerClass"/>
        <l-tile-layer
            v-for="tileProvider in stravaProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :options="tileProvider.tileOptions"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution"
            :opacity="tileProvider.opacity"
            :layer-type="tileProvider.layerType"
            :tile-layer-class="tileProvider.layerClass"/>

        <l-marker v-for="(marker, index) in markers()"
                  v-bind:key="'marker_'+index"
                  :lat-lng="marker.point"
                  :radius="1"
                  :icon="markerIcon(marker)"
                  :draggable="settings.editMode === 2"
                  ref="popup"
                  @contextmenu="onMarkerMenu($event, marker)"
                  @mouseover="onMarkerMouseOver(marker)"
                  @mouseout="onMarkerMouseOut($event)"
                  @drag="moveMarker($event.target, marker.markerId)"
                  @dragend="movedMarker(marker.markerId)">
        </l-marker>
        <l-marker v-for="(marker, index) in pmarkers()"
                  v-bind:key="'pmarker_'+index"
                  :lat-lng="marker.point"
                  :radius="1"
                  :icon="selIcon"
                  @click="onPMarkerClick(marker)"
                  :draggable="false"
                  ref="popup">
        </l-marker>
        <l-marker v-for="(marker, index) in waypoints"
                  v-bind:key="'wp_'+index"
                  :lat-lng="marker.point"
                  @click="onWpClick(marker)"
                  :draggable="settings.editMode === 4"
                  ref="popup">
        </l-marker>
        <l-marker v-for="(marker, index) in amarkers" v-bind:key="'amarker_'+index" :lat-lng="marker.point" :radius="1"
                  :icon="marker.icon"
                  :draggable="false">
        </l-marker>
        <l-polyline v-for="(path, index) in paths" ref="polylines" v-bind:key="index" :lat-lngs="path.path.points"
                    @contextmenu="onPolylineMenu($event, path.path)"
                    :weight="pathWeight(path)"
                    :color="pathColor(path)" :opacity="path.file.opacity">
        </l-polyline>
        <l-polyline ref="pendingpoly"
                    :lat-lngs="editpath"
                    :weight="8"
                    color="#ffde00"
                    :opacity="0.8">
        </l-polyline>
        <l-polyline ref="ppendingpoly"
                    :lat-lngs="peditpath"
                    :weight="8"
                    color="#04ffbb"
                    :opacity="0.9">
        </l-polyline>
      </l-map>

    </v-main>
    <v-footer ref="footer" :height="settings.bottomHeight" padless color="#ddd">
      <div class="foot-border"></div>
      <div class="foot-content">
        <v-data-table
            dense
            ref="datatab"
            v-model="selected"
            :headers="headers"
            :items="files.files"
            :single-select="singleSelect"
            item-key="file"
            show-select
            hide-default-footer
            class="elevation-0"
            fixed-header
            :height="tableHeight"
            disable-pagination
            @dblclick:row="panTrack"
        >
          <template v-slot:top>
            <div class="listtop">
              <div>
                <input type=file @change="onFileChange" ref="addfile" style="display:none" accept=".gpx"/>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <Settings v-bind="attrs" v-on="on" v-model="settings"></Settings>
                  </template>
                  <span>Settings</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="mybuttnr" small @click="onClickFile">mdi-file-upload
                    </v-icon>
                  </template>
                  <span>Add file</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="mybuttnr" small @click="onSave()">mdi-content-save</v-icon>
                  </template>
                  <span>Save state</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="buttonMultiple" small @click="onTrash()">mdi-trash-can
                    </v-icon>
                  </template>
                  <span>Remove files</span>
                </v-tooltip>
               <!-- <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="buttonMultiple" small>mdi-auto-fix</v-icon>
                  </template>
                  <span>Process tracks</span>
                </v-tooltip> -->
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="buttonSingle" @click="onDownload" small>mdi-file-download
                    </v-icon>
                  </template>
                  <span>Download file</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="buttonSingle" @click="onDownloadFit" small>mdi-alpha-f-box
                    </v-icon>
                  </template>
                  <span>Download file</span>
                </v-tooltip>
              </div>
              <div>
                <span>
                  {{ markerLocation }}
                </span>
                <span>
                  &nbsp;&nbsp;
                </span>
                <span v-if="settings.editMode === 3" class="editlen">
                  Edit path length: {{
                    editPathDistance.toFixed(1)
                  }} ({{ (editPathDistance + peditPathDistance).toFixed(1) }})
                </span>
                <span>
                  &nbsp;&nbsp;
                </span>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="mybuttn" small>mdi-help</v-icon>
                  </template>
                  <span>Halp</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="editModeButton(1)" @click="toggleMode(1)" small>
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span>Draw mode - zoom in to draw and extend tracks</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="editModeButton(2)" @click="toggleMode(2)" small>
                      mdi-hammer-screwdriver
                    </v-icon>
                  </template>
                  <span>Edit mode - zoom in to edit points, split tracks</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="editModeButton(3)" @click="toggleMode(3)" small>
                      mdi-link-variant
                    </v-icon>
                  </template>
                  <span>Join tracks</span>
                </v-tooltip>
                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="editModeButton(4)" @click="toggleMode(4)" small>
                      mdi-map-marker
                    </v-icon>
                  </template>
                  <span>Edit waypoints</span>
                </v-tooltip>                <v-tooltip bottom :disabled="settings.tooltipsDisabled">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" :class="settings.showDirection  ? 'mybuttn-selected' : 'mybuttn'"
                            @click="settings.showDirection = !settings.showDirection" small>
                      mdi-swap-vertical
                    </v-icon>
                  </template>
                  <span>Show/hide track direction</span>
                </v-tooltip>
              </div>
            </div>
          </template>
          <template v-slot:[`item.length`]="{ item }">
            {{ item.length.toFixed(1) }}
          </template>
          <template v-slot:[`item.gain`]="{ item }">
            {{ item.gain.toFixed(0) }}
          </template>
          <template v-slot:[`item.color`]="{ item, index }">
            <ColorPicker v-model="item.color"/>
            <v-icon dense @click="item.cycle_opacity()">{{ item.opacity_icon() }}</v-icon>
            <v-icon dense @click="to_front(index)">mdi-arrange-bring-to-front</v-icon>
          </template>
        </v-data-table>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import {LMap, LMarker, LPolyline, LTileLayer, LControlLayers} from "vue2-leaflet";
import * as L from "leaflet";
import * as GPX from "../gpx-path";
import * as SETT from "../settings";
import ColorPicker from "@/components/ColorPicker";
import Settings from "@/components/Settings";
import {OpenStreetMapProvider} from 'leaflet-geosearch';
import VGeosearch from 'vue2-leaflet-geosearch';
import * as LE from "esri-leaflet";
import axios from "axios";


let CustomBoxZoom = L.Map.BoxZoom.extend({
  _onMouseUp: function (e) {
    if (e.which !== 1 && e.button !== 1) return;
    this._finish();
    if (!this._moved) return;
    this._clearDeferredResetState();
    this._resetStateTimeout = setTimeout(L.bind(this._resetState, this), 0);
    const latlng1 = this._map.containerPointToLatLng(this._startPoint);
    const latlng2 = this._map.containerPointToLatLng(this._point);
    const bounds = L.latLngBounds(latlng1, latlng2);
    this._map.fire('boxzoomend', {boxZoomBounds: bounds, ctrlKey: e.ctrlKey});
  },
});
L.Map.addInitHook('addHandler', 'customBoxZoom', CustomBoxZoom);

export default {
  name: "GeometryTest",
  components: {
    Settings,
    ColorPicker,
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LControlLayers,
    VGeosearch
    //,
    //LPopup
  },
  computed: {
    stravaProviders: function () {
      if (this.settings.stravakeyId) {
        let r = [];
        for (let e of this.rawStravaProviders) {
          let y = Object.assign({}, e);
          y['url'] = e['url'] + '?Key-Pair-Id=' + this.settings.stravakeyId + '&Policy=' + this.settings.stravakeyPolicy +
              '&Signature=' + this.settings.stravakeySignature;
          r.push(y);
        }
        return r;
      } else {
        return [];
      }
    },
    tableHeight: function () {
      return this.settings.bottomHeight - 36;
    },
    waypoints: function() {
      let m = [];
      for (let fileIx = 0; fileIx < this.files.files.length; ++fileIx) {
        let f = this.files.files[fileIx];
        if (f.opacity > 0) {
          for (let j = 0; j < f.waypoints.length; ++j) {
            let w = f.waypoints[j];
            let markerId = {fileix: fileIx,  index: j};
            m.push({markerId: markerId, file: f, point: w});
          }
        }
      }
      return m;
     },
    amarkers: function () {
      if (!this.settings.showDirection) {
        return [];
      }
      this.recomputeMarker;
      if (!this.$refs.map) {
        return [];
      }
      const mmap = this.$refs.map.mapObject;
      if (mmap.getZoom() < 6) {
        return [];
      }
      let mapBounds = mmap.getBounds();
      let newm = [];
      for (let file of this.files.files) {
        if (file.opacity === 0) {
          continue;
        }
        for (let pathIx = 0; pathIx < file.paths.length; pathIx++) {
          let path = file.paths[pathIx];
          let lastarrow = null;
          for (let i = 0; i < path.points.length - 1; ++i) {
            if (mapBounds.contains(path.points[i])) {
              let icon;
              let pointA = mmap.project(path.points[i]);
              if (lastarrow && pointA.distanceTo(lastarrow) < 150) {
                continue;
              }
              let pointB = mmap.project(path.points[i + 1]);
              lastarrow = pointA.add(pointB).divideBy(2);
              let midP = mmap.unproject(lastarrow);
              icon = L.divIcon({
                className: 'arrow-icon',
                bgPos: [0, 0],
                iconAnchor: [8, 8],
                html: '<div style="transform: rotate(' + this.getAngle(path.points[i], path.points[i + 1], -1).toString() + 'deg)"><img src="arrow.svg" width="16px" height="16px"></div>'
              });
              newm.push({point: midP, icon: icon});
            }
          }
        }
      }
      return newm;
    },
    paths: function () {
      let res = [];
      for (let f of this.files.files) {
        for (let p of f.paths) {
          res.push({file: f, path: p});
        }
      }
      return res;
    },
    buttonSingle: function () {
      return this.selected.length === 1 ? 'mybuttnr' : 'mybuttnr-disabled';
    },
    buttonMultiple: function () {
      return this.selected.length > 0 ? 'mybuttnr' : 'mybuttnr-disabled';
    },
  },
  data() {
    return {
      geosearchOptions: { // Important part Here
        provider: new OpenStreetMapProvider(),
        position: 'topleft',
        showMarker: false,
        showPopup: false,
        retainZoomLevel: false,
        autoClose: true
      },
      singleSelect: false,
      selected: [],
      mapOptions: {
        contextmenu: true,
        contextmenuWidth: 140,
        contextmenuItems: [],
        boxZoom: false, customBoxZoom: true
      },
      headers: [
        {
          text: 'File',
          align: 'start',
          sortable: false,
          value: 'file',
        },
        {text: 'Points', value: 'size'},
        {text: 'Tracks', value: 'tracks'},
        {text: 'Length', value: 'length'},
        {text: 'Gain', value: 'gain'},
        {text: 'Options', value: 'color'}
      ],
      settings: new SETT.AutoSettings(),
      recomputeMarker: 0,
      lbl: "Upload",
      zoom: 11,
      maxZoom: 24,
      curwp: {name: "", description: "", type: ""},
      curMarker: null,
      wpdialog: false,
      wptypes: [
        "GENERIC",
        "AID_STATION",
        "TOILET",
        "SUMMIT",
        "VALLEY",
        "WATER",
        "FOOD",
        "DANGER",
        "CHECKPOINT",
        "SERVICE",
        "ENERGY_GEL",
        "SPORTS_DRINK",
        "LEFT",
        "RIGHT",
        "STRAIGHT",
        "FIRST_AID",
        "SPRINT",
        "LEFT_FORK",
        "RIGHT_FORK",
        "MIDDLE_FORK",
        "SLIGHT_LEFT",
        "SHARP_LEFT",
        "SLIGHT_RIGHT",
        "SHARP_RIGHT",
        "U_TURN",
        "SEGMENT_START",
        "SEGMENT_END",
        "CAMPSITE",
        "REST_AREA",
        "GENERAL_DISTANCE",
        "MILE_MARKER",
        "SHELTER",
        "MEETING_SPOT",
        "OVERLOOK",
        "SHOWER",
        "GEAR",
        "SHARP_CURVE",
        "STEEP_INCLINE",
        "TUNNEL",
        "BRIDGE",
        "OBSTACLE",
        "CROSSING",
        "STORE",
        "TRANSITION",
        "NAVAID",
        "TRANSPORT",
        "ALERT",
        "INFO"
      ],
      tileProviders: [
        {
          name: "Outdoor",
          tileOptions: {
            maxNativeZoom: 18,
            maxZoom: 24
          },
          url: 'https://tile.thunderforest.com/outdoors/{z}/{x}/{y}{r}.png?apikey=ae9df75f0c9e49dc9ed8b0ffc44da91a',
          attribution: 'Maps &copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, Data &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          visible: true,
          opacity: 1.0,
          layerType: 'base',
        },
        {
          name: "Cycle",
          tileOptions: {
            maxNativeZoom: 18
          },
          url: 'https://tile.thunderforest.com/cycle/{z}/{x}/{y}{r}.png?apikey=ae9df75f0c9e49dc9ed8b0ffc44da91a',
          attribution: 'Maps &copy; <a href="http://www.thunderforest.com/">Thunderforest</a>, Data &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          visible: false,
          opacity: 1.0,
          layerType: 'base'
        },
        {
          name: 'OSM',
          attribution: 'Map data from <a target="_blank" href="https://www.openstreetmap.org/copyright">OpenStreetMap.org</a>',
          tileOptions: {
            maxNativeZoom: 19
          },
          opacity: 1.0,
          visible: false,
          layerType: 'base',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        },
        {
          name: "USFS (Caltopo)",
          opacity: 1.0,
          tileOptions: {
            minNativeZoom: 8,
            maxNativeZoom: 16
          },
          visible: false,
          layerType: 'base',
          attribution: 'US Forest Service topos from <a target="_blank" href="https://www.caltopo.com/">CalTopo.com</a>',
          url: 'https://ctusfs.s3.amazonaws.com/2016a/{z}/{x}/{y}.png'
        },

        {
          name: "ArcGIS Clarity",
          tileOptions: {
            maxNativeZoom: 19
          },
          url: 'https://clarity.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.jpg',
          attribution: 'Aerial imagery from <a target="_blank" href="https://clarity.maptiles.arcgis.com/arcgis/rest/services/World_Imagery/MapServer">ESRI/ArcGIS</a>',
          visible: false,
          opacity: 1.0,
          layerType: 'base'
        },

        {
          name: "Land Ownership",
          tileOptions: {
            maxNativeZoom: 15
          },
          url: 'https://caltopo.com/tile/sma/{z}/{x}/{y}.png',
          attribution: 'Ownership data from <a target="_blank" href="https://caltopo.com/">CalTopo</a>',
          opacity: 1.0,
          visible: false,
          layerType: 'overlay'
        },
        {
          name: "Arcgis Relief",
          attribution: 'Relief shading from <a target="_blank" href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Shaded_Relief/MapServer">ESRI/ArcGIS</a>',
          tileOptions: {
            minNativeZoom: 1,
            maxNativeZoom: 13,
            className: "leaflet-layer mapblending",
          },
          url: 'https://server.arcgisonline.com/arcgis/rest/services/Elevation/World_Hillshade/MapServer/tile/{z}/{y}/{x}.jpg',

          opacity: 1.0,
          visible: false,
          layerType: 'overlay'
        }
      ],
      rawStravaProviders: [
        {
          name: "Heatmap hi-res",
          tileOptions: {
            maxNativeZoom: 15
          },
          attribution: "&copy; Strava",
          visible: false,
          opacity: 1.0,
          layerType: 'overlay',
          url: 'https://heatmap-external-{s}.strava.com/tiles-auth/all/hot/{z}/{x}/{y}.png'
        },
        {
          name: "Heatmap run",
          tileOptions: {
            maxNativeZoom: 15
          },
          attribution: "&copy; Strava",
          visible: false,
          opacity: 1.0,
          layerType: 'overlay',
          url: 'https://heatmap-external-{s}.strava.com/tiles-auth/run/hot/{z}/{x}/{y}.png'
        },
        {
          name: "Heatmap bike",
          tileOptions: {
            maxNativeZoom: 15
          },
          attribution: "&copy; Strava",
          visible: false,
          opacity: 1.0,
          layerType: 'overlay',
          url: 'https://heatmap-external-{s}.strava.com/tiles-auth/ride/hot/{z}/{x}/{y}.png'
        },
      ],
      dialog: false,
      savePoints: null,
      eleshow: false,
      saveName: "",
      saveFileName: "",
      undo: [],
      editPathDistance: 0.0,
      peditPathDistance: 0.0,
      markerLocation: "",
      highlightedMarker: null,
      highlightedPath: null,
      selectedMarkers: [],
      center: [40.0779420, -105.5843840],
      files: new GPX.PathList(),
      pop: {className: "custom-popup", closeButton: false, autoPan: false, keepInView: true, offset: [50, 50]},
      icon: L.divIcon({className: "leaflet-div-icon2", iconSize: [8, 8]}),
      highlightedIcon: L.divIcon({className: "leaflet-div-icon2-hi", iconSize: [8, 8]}),
      selIcon: L.divIcon({className: "leaflet-div-icon2-sel", iconSize: [8, 8]}),
      wpIcon: L.divIcon({className: "leaflet-div-icon2-sel", iconSize: [8, 8]}),
      selHighlightedIcon: L.divIcon({className: "leaflet-div-icon2-hi-sel", iconSize: [8, 8]}),
      //url: ,
    };
  },
  methods: {
    markers() {
      this.recomputeMarker;
      if ((this.settings.editMode !== 2) || this.$refs.map.mapObject.getZoom() < 15) {
        return [];
      } else {
        let mapBounds = this.$refs.map.mapObject.getBounds();
        let newm = [];
        for (let fileIx = 0; fileIx < this.files.files.length; ++fileIx) {
          let file = this.files.files[fileIx];
          if (file.opacity === 0) {
            continue;
          }
          for (let pathIx = 0; pathIx < file.paths.length; pathIx++) {
            let path = file.paths[pathIx];
            for (let i = 0; i < path.points.length; ++i) {
              if (mapBounds.contains(path.points[i])) {
                let markerId = {fileix: fileIx, pathix: pathIx, index: i};
                newm.push({markerId: markerId, file: file, point: path.points[i]});
              }
            }
          }
        }
        if (newm.length < 4000) {
          return newm;
        }
        return []
      }
    },
    pmarkers() {
      this.recomputeMarker;
      let pmarkers = [];
      for (let fileIx = 0; fileIx < this.files.files.length; ++fileIx) {
        let file = this.files.files[fileIx];
        if (file.opacity === 0) {
          continue;
        }
        for (let pathIx = 0; pathIx < file.paths.length; pathIx++) {
          let path = file.paths[pathIx];
          for (let i = 1; i < path.points.length; ++i) {
            if (path.points[i].ts && path.points[i].ts - path.points[i - 1].ts > 1800) {
              let markerId = {fileix: fileIx, pathix: pathIx, index: i};
              pmarkers.push({markerId: markerId, file: file, point: path.points[i]});
            }
          }
        }
      }
      return pmarkers;
    },
    getAngle(latLng1, latlng2, coef) {
      let dy = latlng2.lat - latLng1.lat;
      let dx = Math.cos(Math.PI / 180 * latLng1.lat) * (latlng2.lng - latLng1.lng);
      let ang = ((Math.atan2(dy, dx) / Math.PI) * 180 * coef);
      return (ang).toFixed(2);
    },
    onMenuHide() {
      this.$refs.map.mapObject.contextmenu.removeAllItems();
    },
    cls() {
      this.selectedMarkers = [];
    },
    addToJoin(path) {
      if (this.settings.editMode !== 3) {
        return;
      }
      this.editpath = path.path.points;
      this.$refs.pendingpoly.mapObject.bringToBack()
    },
    mapClick(event) {
      if (this.settings.editMode == 4) {
        let p = this.files.nearestFile(event.latlng);
        if (p == null) {
          return;
        }
        p.addWaypoint(event.latlng);
        return;
      }
      if (this.settings.editMode !== 3) {
        return;
      }
      if (this.editpath.length === 0) {
        if (event.originalEvent.shiftKey) {
          this.editpath.push(event.latlng);
          this.undo.push({at: 0, length: 1});
        } else {
          let close = this.files.nearest(event.latlng);
          if (close.dist <= 40) {
            this.editpath.push(close.point);
            this.undo.push({at: 0, length: 1});
          }
          this.$refs.pendingpoly.mapObject.setLatLngs(this.editpath);
        }
      } else {
        if (event.originalEvent.shiftKey) {
          this.editpath.push(event.latlng);
          this.undo.push({at: this.editpath.length - 1, points: 1});
        } else {
          let closest = this.files.findClosestShortest(this.editpath, event.latlng);
          if (closest) {
            let pointid = closest.pointid;
            let delta = closest.minIndex < closest.pathix ? 1 : -1;
            let total = 0;
            for (let i = closest.minIndex; i !== closest.pathix; i += delta) {
              ++total;
              if (pointid === 0) {
                this.editpath.splice(0, 0, closest.path.points[i])
              } else {
                this.editpath.push(closest.path.points[i]);
              }
            }
            ++total;
            if (pointid === 0) {
              this.editpath.splice(0, 0, closest.path.points[closest.pathix]);
              this.undo.push({at: 0, points: total});
            } else {
              this.editpath.push(closest.path.points[closest.pathix]);
              this.undo.push({at: this.editpath.length - total, points: total});
            }
          }
        }
        this.$refs.pendingpoly.mapObject.setLatLngs(this.editpath);
      }
      this.updateEditPathDistance();
      this.onMapMouseMove(event);
    },
    onMapKey(event) {
      if (this.settings.editMode !== 3) {
        return;
      }
      if (event.originalEvent.key === 'u') {
        this.undoEdit();
      }
      if (event.originalEvent.key === 's') {
        this.openSaveDialog();
      }
      if (event.originalEvent.key === ' ') {
        this.undo.push({at: this.editpath.length, points: this.peditpath.length});
        this.editpath = this.editpath.concat(this.peditpath);
        this.$refs.pendingpoly.mapObject.setLatLngs(this.editpath);
        this.clearPEditPath();
        this.updateEditPathDistance();
      }
    },
    clearPEditPath() {
      this.peditpath = [];
      this.$refs.ppendingpoly.mapObject.setLatLngs(this.peditpath);
      this.updatePEditPathDistance();
    },
    onMapMouseMove(event) {
      if (this.settings.editMode !== 3) {
        return;
      }
      if (this.editpath.length !== 0) {
        this.peditpath = [];
        let closest = this.files.findClosestShortest(this.editpath, event.latlng);
        if (closest) {
          let pointid = closest.pointid;
          let delta = closest.minIndex < closest.pathix ? 1 : -1;
          for (let i = closest.minIndex; i !== closest.pathix; i += delta) {
            if (pointid === 0) {
              this.peditpath.splice(0, 0, closest.path.points[i])
            } else {
              this.peditpath.push(closest.path.points[i]);
            }
          }
          if (pointid === 0) {
            this.peditpath.splice(0, 0, closest.path.points[closest.pathix]);
          } else {
            this.peditpath.push(closest.path.points[closest.pathix]);
          }
        }
        this.$refs.ppendingpoly.mapObject.setLatLngs(this.peditpath);
        this.updatePEditPathDistance();
      }
    },
    undoEdit() {
      if (this.undo.length > 0) {
        let u = this.undo.pop();
        this.editpath.splice(u.at, u.points);
        this.$refs.pendingpoly.mapObject.setLatLngs(this.editpath);
        this.updateEditPathDistance();
        this.clearPEditPath();
      }
    },
    clearEdit() {
      this.undo = [];
      this.editpath = [];
      this.$refs.pendingpoly.mapObject.setLatLngs(this.editpath);
      this.updateEditPathDistance();
      this.clearPEditPath();
    },
    updateEditPathDistance() {
      let l = 0;
      for (let i = 0; i < this.editpath.length - 1; ++i) {
        l += this.editpath[i].distanceTo(this.editpath[i + 1]);
      }
      this.editPathDistance = l / 1609.34;
    },
    updatePEditPathDistance() {
      let l = 0;
      for (let i = 0; i < this.peditpath.length - 1; ++i) {
        l += this.peditpath[i].distanceTo(this.peditpath[i + 1]);
      }
      this.peditPathDistance = l / 1609.34;
    },
    onWpClick(marker) {
      this.curMarker = marker;
      this.curwp.name = marker.point.name;
      this.curwp.description = marker.point.description;
      this.curwp.type = marker.point.type;
      this.wpdialog = true;
    },
    deleteWp() {
      this.curMarker.file.deleteWaypoint(this.curMarker.markerId.index);
    },
    saveWp() {
      this.curMarker.point.name = this.curwp.name;
      this.curMarker.point.description = this.curwp.description;
      this.curMarker.point.type = this.curwp.type;
    },
    onPMarkerClick(marker) {
      this.markerLocation = `${marker.point.lat},${marker.point.lng}`;
    },
    pathColor(path) {
      if (this.settings.editMode !== 3) {
        return path.file.color;
      }
      if (this.highlightedPath === path) {
        return "orange";
      }
      return path.file.color;
    },
    pathWeight(path) {
      if (this.settings.editMode !== 3) {
        return 3;
      }
      if (this.highlightedPath === path) {
        return 10;
      }
      return 3;
    },
    pathMouseover(path) {
      if (this.settings.editMode !== 3) {
        return;
      }
      this.highlightedPath = path;
    },
    pathMouseout() {
      if (this.settings.editMode !== 3) {
        return;
      }
      if (this.highlightedPath) {
        this.highlightedPath = null;
      }
    },
    onMarkerKey(event) {
      if (this.highlightedMarker != null) {
        if (event.originalEvent.key === " ") {
          let ix = this.selectedIndex(this.highlightedMarker);
          if (ix >= 0) {
            this.selectedMarkers.splice(ix, 1);
            if (!event.originalEvent.ctrlKey) {
              this.cls();
            }
          } else {
            if (!event.originalEvent.ctrlKey) {
              this.cls();
            }
            this.selectedMarkers.push(this.highlightedMarker);
          }

        } else if (event.originalEvent.code === "Delete") {
          this.removeMarker(this.highlightedMarker)
        }
      }
    },
    isHighlighted(markerId) {
      return this.highlightedMarker &&
          this.highlightedMarker.fileix === markerId.fileix &&
          this.highlightedMarker.pathix === markerId.pathix &&
          this.highlightedMarker.index === markerId.index;
    },
    selectedIndex(markerId) {
      let isEqual = function (arg) {
        return arg.fileix === markerId.fileix && arg.pathix === markerId.pathix && arg.index === markerId.index
      };
      return this.selectedMarkers.findIndex(isEqual);
    },
    markerIcon(marker) {
      let sel = this.selectedIndex(marker.markerId) >= 0;
      let hi = this.isHighlighted(marker.markerId);
      if (sel && hi) {
        return this.selHighlightedIcon;
      } else if (sel) {
        return this.selIcon;
      } else if (hi) {
        return this.highlightedIcon;
      } else {
        return this.icon;
      }
    },
    onMarkerMouseOver(marker) {
      this.$refs.map.$el.focus();
      this.highlightedMarker = marker.markerId;
    },
    onMarkerMouseOut(event) {
      if (event.originalEvent.buttons === 0) {
        this.highlightedMarker = null;
      }
    },
    onDownload() {
      let data = this.selected[0].serialize();
      const url = window.URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.selected[0].file) //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    async onDownloadFit() {
      let gpx = this.selected[0].serialize();
      let data = await axios.post("https://gpxtofit-394123.wl.r.appspot.com/gpx2fit", gpx, {
        responseType: 'arraybuffer'})
      const url = window.URL.createObjectURL(new Blob([data.data]))
      const link = document.createElement('a')
      link.href = url
      let fn = this.selected[0].file;
      if (fn.endsWith(".gpx")) {
        fn = fn.substring(0, fn.length - 4)
      }
      fn = fn + ".fit"
      link.setAttribute('download', fn) //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    onMarkerMenu(event, marker) {
      if (this.selectedMarkers.length > 0) {
        this.$refs.map.mapObject.contextmenu.addItem({
          text: '<div class="menuentry">Remove selected<div class="kb">S-DEL</div></div>',
          callback: () => this.removeSelected()
        })
      }
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Remove <div class="kb">DEL</div></div>',
        callback: () => this.removeMarker(marker.markerId)
      })
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Split <div class="kb">S</div></div>',
        callback: () => this.splitPath(marker.markerId)
      })
      this.$refs.map.mapObject.contextmenu.showAt(event.latlng);
    },
    onMapMenu(event) {
      if (this.settings.editMode == 3) {
        this.$refs.map.mapObject.contextmenu.addItem({
          text: '<div class="menuentry">Undo<div class="kb">u</div></div>',
          callback: () => this.undoEdit()
        });
        this.$refs.map.mapObject.contextmenu.addItem({
          text: '<div class="menuentry">Clear<div class="kb">S-DEL</div></div>',
          callback: () => this.clearEdit()
        });
        this.$refs.map.mapObject.contextmenu.addItem({
          text: '<div class="menuentry">Save<div class="kb">s</div></div>',
          callback: () => this.openSaveDialog()
        });
      }
      this.$refs.map.mapObject.contextmenu.showAt(event.latlng);
    },
    onPolylineMenu(event, marker) {
      this.$refs.map.mapObject.contextmenu.addItem({text: `${marker.file.file}, t${marker.file.indexOf(marker)}`})
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Reverse <div class="kb">R</div></div>',
        callback: () => this.reverse(marker)
      })
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Simplify <div class="kb">S</div></div>',
        callback: () => this.simplify(marker)
      })
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Simplify < 10k pts<div class="kb">S</div></div>',
        callback: () => this.simplify10k(marker)
      })
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Elevation Profile <div class="kb">E</div></div>',
        callback: () => this.eledraw(marker, true)
      })
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Elevation Profile (metric)<div class="kb">K</div></div>',
        callback: () => this.eledraw(marker, false)
      })
      this.$refs.map.mapObject.contextmenu.addItem({
        text: '<div class="menuentry">Split File<div class="kb">E</div></div>',
        callback: () => this.openSplitDialog(marker)
      })

      //   this.$refs.map.mapObject.contextmenu.addItem({
      //     text: '<div class="menuentry">Realify <div class="kb">R</div></div>',
      //     callback: () => this.realify(marker)
      //   })
      this.$refs.map.mapObject.contextmenu.showAt(event.latlng);
    },
    toggleMode(target) {
      if (this.settings.editMode === target) {
        this.settings.editMode = 0;
      } else {
        this.settings.editMode = target;
      }
    },
    editModeButton(target) {
      return this.settings.editMode === target ? 'mybuttn-selected' : 'mybuttn';
    },
    onSave() {
      this.files.save(false, this.$refs.map.mapObject.getBounds());
    },
    to_front(index) {
      this.$refs.polylines[index].mapObject.bringToFront();
    },
    onTrash() {
      this.files.remove(this.selected);
      this.selected.clear();
    },
    setEvents() {
      //const minSize = 3;
      const el = this.$refs.footer.$el;
      const drawerBorder = el.querySelector(".foot-border");
      const map = this.$refs.map.mapObject;
      const vm = this;

      //const datatab = this.$refs.datatab.$el

      function resize(e) {
        document.body.style.cursor = "ns-resize";
        vm.settings.bottomHeight = document.body.scrollHeight - e.clientY;
      }

      drawerBorder.addEventListener(
          "mousedown",
          // eslint-disable-next-line no-unused-vars
          (e) => {
            el.style.transition = "initial";
            document.addEventListener("mousemove", resize, false);
          },
          false
      );

      document.addEventListener(
          "mouseup",
          () => {
            el.style.transition = "";
            //this.bottomHeight = el.style.height;
            document.body.style.cursor = "";
            document.removeEventListener("mousemove", resize, false);
            vm.$nextTick(() => map.invalidateSize(true));
          },
          false
      );
    },
    onFileChange(evt) {
      let files = evt.target.files;
      if (files.length > 0) {
        const reader = new FileReader();
        reader.onload = e => this.handleLoad(files[0].name, e);

        reader.readAsText(files[0]);
      }
    },
    onClickFile() {
      this.$refs.addfile.click();
    },
    handleLoad(name, e) {
      let file = GPX.GpxFile.loadFromFile(name, e.target.result);
      this.files.files.push(file);
      this.$refs.addfile.value = "";
    },
    onMapDrag(event) {
      if (!event.ctrlKey) {
        this.cls();
      }
      let marks = this.markers();
      for (let m of marks) {
        if (event.boxZoomBounds.contains(m.point)) {
          if (this.selectedIndex(m.markerId) < 0) {
            this.selectedMarkers.push(m.markerId);
          }
        }
      }
    },
    saveEdit() {
      this.files.files.push(new GPX.GpxFile({file: this.saveFileName, name: this.saveName}, this.savePoints));
      this.editpath = [];
      this.peditpath = [];
    },
    updateZoom() {
      this.settings.bounds = this.$refs.map.mapObject.getBounds();
      for (let p of this.$refs.popup || []) {
        p.mapObject.closePopup();
      }
      this.recomputeMarker += 1;
    },
    panTrack(a1, a2) {
      this.$refs.map.mapObject.fitBounds(this.files.files[a2.index].bounds());
    },
    removeMarker(ref) {
      let path = this.files.files[ref.fileix].paths[ref.pathix];
      path.points.splice(ref.index, 1);
      this.updatePath(path, true);
      this.selectedMarkers = [];
      this.recomputeMarker++;
    },
    splitPath(ref) {
      this.selectedMarkers = [];
      this.files.files[ref.fileix].split(ref.pathix, ref.index);
      this.updatePath(this.files.files[ref.fileix].paths[ref.pathix], false);
      this.recomputeMarker++;
    },
    removeSelected() {
      let compare = function (a, b) {
        return b.index - a.index;
      }
      this.selectedMarkers.sort(compare);
      let paths = new Set();
      for (let ref of this.selectedMarkers) {
        let path = this.files.files[ref.fileix].paths[ref.pathix];
        paths.add(path);
        path.points.splice(ref.index, 1);
      }
      for (let path of paths) {
        this.updatePath(path, true);
      }
      this.selectedMarkers = [];
      this.recomputeMarker++;
    },
    bg(col) {
      return `background-color: ${col}`;
    },
    moveMarker(event, ref) {
      let path = this.files.files[ref.fileix].paths[ref.pathix];
      let alt = path.points[ref.index].alt;
      path.points[ref.index] = event.getLatLng();
      if (alt) {
        path.points[ref.index].alt = alt;
      }
      this.updatePath(path, false);
    },
    movedMarker(ref) {
      this.updatePath(this.files.files[ref.fileix].paths[ref.pathix], true);
      ++this.recomputeMarker;
      this.highlightedMarker = null;
    },
    updatePath(path, set) {
      let ix = -1;
      let pix = -1;
      for (let f = 0; f < this.files.files.length; ++f) {
        for (let p = 0; p < this.files.files[f].paths.length; p++) {
          ++ix;
          if (this.files.files[f].paths[p] === path) {
            pix = ix;
            if (set) {
              this.$set(this.files.files[f].paths, p, path.update())
            }
            break;
          }
        }
        if (pix >= 0) {
          break;
        }
      }
      if (pix >= 0) {
        this.$refs.polylines[pix].mapObject.setLatLngs(path.points);
      }
    },
    simplify(path) {
      this.cls();
      path.simplify(1);
      this.updatePath(path, true);

    },
    simplify10k(path) {
      this.cls();
      let s = 1.0
      while (s < 20) {
        path.simplify(s);
        this.updatePath(path, true);
        if (path.points.length < 10000) break;
        s = s + 1;
      }
    },
    realify(path) {
      this.cls();
      path.realify(1651344730, 1651361842);
      this.updatePath(path, true);
    },
    reverse(path) {
      this.cls();
      path.reverse();
      this.updatePath(path, true);
    },
    addMarker(event) {
      if (this.$refs.map.mapObject.getZoom() >= 17) {
        // let closest = this.findClosest(event, 200);
        console.log(event);
        //this.markers.push(event.latlng);
      }
    },
    doLoad() {
      this.files.load();
    },
    /*       findClosest(event, distance) {
               let cl = -1;
               let cld = distance;
               for (let i = 0; i < this.markers.length; i++) {
                // if (this.markers[i].)
               }
           },*/
    openSaveDialog() {
      this.saveName = '';
      this.saveFileName = '';
      this.dialog = true;
      this.savePoints = this.editpath;
    },
    openSplitDialog(path) {
      this.saveName = '';
      this.saveFileName = '';
      this.dialog = true;
      this.savePoints = path.points;
    },
    eledraw(path, imperial) {
      let c = this.elecanvas;
      let xm = 2000;
      let ym = 800;
      let ft = 40;

      c.beginPath();
      c.fillStyle = "#ffffff";
      c.strokeStyle = "#ffffff";
      c.fillRect(0, 0, xm, ym);
      c.stroke();
      c.fillStyle = "#000000";
      c.strokeStyle = "#000000";
      c.lineWidth = 5;
      c.beginPath();
      c.rect(ft, 5, xm - 5 - ft, ym - ft - 5);
      c.stroke();
      let df = 1.0;
      let hf = 1.0;
      let du = "k";
      //let hu = "m";
      if (imperial) {
        df = 1/1.60934;
        hf = 3.28084;
        du = "m";
        //hu = "ft";
      }
      let [dmin, dmax, emin, emax] = path.elebounds();

      dmin *= df;
      dmax *= df;
      emin *= hf;
      emax *= hf;
      const dscale = this.autoscale(dmax - dmin);
      const escale = this.autoscale(emax - emin);
      const mind = Math.floor(dmin / dscale) * dscale;
      const mine = Math.floor(emin / escale) * escale;
      const maxd = dmax;// Math.ceil(dmax / dscale) * dscale;
      const maxe = Math.ceil(emax / escale) * escale;
      let toX = function (x) {
        return (x - mind) / (maxd - mind) * (xm - 5 - ft) + ft;
      };
      let toY = function (y) {
        return ym - ft - ((y - mine) / (maxe - mine) * (ym - 5 - ft));
      };

      c.lineWidth = 5;
      c.textAlign = "center";
      c.font = "35px Verdana";
      for (let dd = mind + dscale; dd < maxd; dd += dscale) {
        c.beginPath();
        c.moveTo(toX(dd), ym-ft);
        c.lineTo(toX(dd), ym-ft - 20);
        c.fillText(`${dd}`, toX(dd), ym);
        c.stroke();
        c.strokeStyle = "#000000";
      }
      for (let ee = mine + escale; ee < maxe; ee += escale) {
        c.beginPath();
        c.moveTo(ft, toY(ee));
        c.lineTo(ft + 20, toY(ee));
        c.stroke();
        c.strokeStyle = "#000000";
        c.save();
        c.translate(ft-10, toY(ee));
        c.rotate(-Math.PI/2);
        c.fillText(`${ee}`, 0, 0);
        c.restore();
     }

      c.lineWidth = 3;
      c.beginPath();
      c.moveTo(toX(0), toY(path.points[0].alt*hf));
      let d = 0;
      for (let i = 1; i < path.points.length; ++i) {
        d = d + path.points[i].distanceTo(path.points[i-1]);
        c.lineTo(toX(d*df/1000), toY(path.points[i].alt*hf));
      }
      c.stroke();

      let nn = [];
      for (let w of path.file.waypoints) {
        for (let nrst of path.allNearest(w)) {
          nn.push(nrst);
          nn[nn.length - 1].wpt = w;
          nn[nn.length - 1].dist = path.lengthto(nn[nn.length - 1].minIx)*df;
        }
      }
      nn.sort((a,b) => a.dist-b.dist );
      let dila = 0;
      for (let i = 0;i < nn.length; ++i) {
        let n = nn[i];
        let t1 = n.wpt.name;
        let t2 = `${n.dist.toFixed(1)}${du} ${n.wpt.description}`;

        if  (path.lengthkm()*df - n.dist < 0.5) {
          t1 = t2;
          t2 = "";
        }

        let w1 = c.measureText(t1).width;
        let w2 = c.measureText(t2).width;
        let h = 30;
        let w = Math.max(w1, w2);

        let curdila = dila;
        dila = 0;
        if (i < nn.length - 1 && toX(nn[i+1].dist) - toX(n.dist) <= 2*h ) {
          dila = h*2/3;
          curdila = -dila;
        }


        if (n.point.alt*hf < (emax+emin)/2) {
          c.beginPath();
          c.moveTo(toX(n.dist), 25+w);
          c.lineTo(toX(n.dist), toY(n.point.alt*hf));
          c.stroke();
          c.textAlign = 'start';
          c.save();
          c.translate(toX(n.dist)-h/3+curdila, 25+w);
          c.rotate(-Math.PI/2);
          c.fillText(t1, 0, 0);
          c.restore();
          c.save();
          c.translate(toX(n.dist) + h+curdila, 25+w);
          c.rotate(-Math.PI/2);
          c.fillText(t2, 0, 0);
          c.restore();
        }
        if (n.point.alt*hf >= (emax+emin)/2) {
          c.beginPath();
          c.moveTo(toX(n.dist), ym-ft-25-w);
          c.lineTo(toX(n.dist), toY(n.point.alt*hf));
          c.stroke();
          c.textAlign = 'start';
          c.save();
          c.translate(toX(n.dist)-h/3+curdila, ym-ft-25);
          c.rotate(-Math.PI/2);
          c.fillText(t1, 0, 0);
          c.restore();
          c.save();
          c.translate(toX(n.dist) + h+curdila, ym-ft-25);
          c.rotate(-Math.PI/2);
          c.fillText(t2, 0, 0);
          c.restore();

        }
      }
      this.eleshow = true;

    },
    autoscale(delta) {
      let scale = 1000000;
      let factors = [2, 2, 2.5];
      for (let i = 0; i < 20; ++i) {
        if (delta / scale >= 4) {
          break;
        }
        scale /= factors[i % 3];
      }
      return scale;
    }
  },
  mounted() {
    this.elecanvas = this.$refs['elecv'].getContext('2d');
    this.$refs['elecv'].width = 2000;
    this.$refs['elecv'].height = 800;
    this.setEvents();
    this.doLoad();
    this.$refs.map.mapObject.addEventListener('contextmenu.hide', this.onMenuHide);
    this.$refs.map.$el.focus();
    this.editpath = [];
    this.peditpath = [];
    let vm = this;
    this.$nextTick(() => {
          vm.settings.load();
          vm.$nextTick(() => {
            vm.$refs.map.mapObject.invalidateSize(true);
            if (vm.settings.bounds) {
              vm.$refs.map.mapObject.fitBounds(vm.settings.bounds);
            }
          });
          LE.imageMapLayer(
              {
                url: "https://maps.bouldercolorado.gov/arcgis2/rest/services/osmp/WildlifeClosuresCurrentClimbingAccessHCA/MapServer/export",
                attribution: "Boulder OSMP",
                opacity: 0.25
              }).addTo(
              vm.$refs.map.mapObject);
        }
    );
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}


</style>
